
export default class ClipboardExt {

    constructor(quill: any, options: any) {

        //convert img links to actual images
        quill.clipboard.addMatcher(Node.TEXT_NODE, function (node: any, delta: any) {
            var regex = /https?:\/\/[^\s]+/g;
            if (typeof (node.data) !== 'string') return;
            var matches = node.data.match(regex);

            if (matches && matches.length > 0) {
                var ops: Array<any> = [];
                var str = node.data;

                matches.forEach(function (match: any) {
                    var split = str.split(match);

                    if (options.youtube === true && match.match(/^((http|https)\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/) != null) {
                        const beforeLink = split.shift();
                        ops.push({ insert: beforeLink });
                        ops.push({
                            insert: { youtube: match },
                            attributes: { link: match }
                        });

                        str = split.join(match);
                    }
                    else if (options.image === true && match.match(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|jpeg|gif|png)/) != null) {
                        const beforeLink = split.shift();
                        ops.push({ insert: beforeLink });
                        ops.push({
                            insert: { imageUrl: match }, attributes: { link: match }
                        });

                        str = split.join(match);
                    }
                    else if (options.video === true && match.match(/(http(s?):)([/|.|\w|\s|-])*\.(?:mp4)/) != null) {
                        const beforeLink = split.shift();
                        ops.push({ insert: beforeLink });
                        ops.push({
                            insert: { videoUrl: match }, attributes: { link: match }
                        });

                        str = split.join(match);
                    }
                    else {
                        //if link is not an image
                        var beforeLink = split.shift();
                        ops.push({ insert: beforeLink });
                        ops.push({
                            insert: match,
                            attributes: { link: match }
                        });
                        str = split.join(match);
                    }
                });
                ops.push({ insert: str });
                delta.ops = ops;
            }
            return delta;
        });

    }

}

//Quill.register('modules/clipboardExt', ClipboardExt);
